import './index.css';

import React, { useEffect } from 'react';
import WarningIcon from '../../asset/icone_atencao.png';

const HOVERED_TRIGGER_SELECTOR = '.warning-icon:hover';
const HOVER_CHECK_INTERVAL_MS = 200;

const Warning = ({ warning: { active, text }, updateWarning }) => {
  useEffect(() => {
    if (!active) return undefined;

    const intervalId = setInterval(() => {
      if (!document.querySelector(HOVERED_TRIGGER_SELECTOR)) updateWarning();
    }, HOVER_CHECK_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [active, updateWarning]);

  return (
    <div
      className={`warning-container ${active ? 'warning-enter' : 'warning-exit'}`}
    >
      <img src={WarningIcon} alt="Aviso"></img>
      <div className="warning-text">{text}</div>
    </div>
  );
};

export default Warning;
